import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { SideNavItem } from '../SideNavItem';
export var StyledCollapsableNavItem = styled.div(_templateObject(), function (props) {
  return "\n        & > ".concat(SideNavItem.Styles.StyledSideNavItem, " > ").concat(SideNavItem.Styles.StyledIcon, " {\n            transition: ").concat(props.theme.components.sideNav.transition, ";\n            transition-property: transform;\n            transition-duration: 300ms;\n            will-change: transform;\n            transition-timing-function: linear;\n\n            ").concat(!props.collapsed ? "\n                        transform: rotate(90deg);\n                    " : '', "\n        }\n    ");
});
export var StyledContent = styled.div(_templateObject2(), function (props) {
  return "\n        transition: ".concat(props.theme.components.sideNav.transition, ";\n        transition-property: max-height, opacity, padding;\n        transition-duration: 600ms;\n        will-change: max-height, opacity, padding;\n        transition-timing-function: linear;\n        max-height: 0;\n        opacity: 0;\n        overflow: hidden;\n        padding-top: 0;\n        padding-bottom: 0;\n\n        ").concat(!props.collapsed ? "\n                    opacity: 1;\n                    max-height: 100vh;\n                    padding: ".concat(props.theme.components.sideNav.item.collapsablePadding, ";\n                ") : '', "\n    ");
});